<div class="container"
     ngClass.lt-md="container-sm"
     ngClass.xs="container-xs">
  <div class="header">
    <h2 class="heading">Closing requirements</h2>
    <button *ngIf="isOfferBundleSelected && checkoutRequirements?.length > 0"
            mat-flat-button
            color="primary"
            (click)="onClickDocuments()">
      <mat-icon>publish</mat-icon>
      Documents
    </button>
  </div>
  <div class="list">
    <div class="item"
         [ngClass]="{'mat-light-grey': requirement.status === checkoutRequirementStatus.Approved}"
         *ngFor="let requirement of checkoutRequirements | filter:filterFunction">
      <mat-icon class="icon"
                matListItemIcon>{{requirement.status === checkoutRequirementStatus.Approved ? 'check_circle' : 'trip_origin'}}</mat-icon>
      <span>{{requirement.requiredDocument}}{{requirement.notes ? ': ' + requirement.notes : ''}}</span>
    </div>
  </div>
</div>
